import { getQuotedValueFromHeader } from './getQuotedValueFromHeader';

export function getClaimsFromHeader(claimsHeader: string | undefined): string | undefined {
    if (claimsHeader) {
        return getQuotedValueFromHeader(claimsHeader, 'claims');
    }
    return undefined;
}
